// ============================================================
// Arquivo centralizado de assets do projeto LovaGO
// Todas as imagens e figuras devem ser referenciadas aqui
// ============================================================

// Logo principal da aplicação (hospedado no CDN da Questera)
export const LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/5f22964fb9b032fe91527ae65177c13422882050f0f2b49d154be5b3ce89a1d6adafbd1f2a8bd63b4674e902697722d9/images/aW1hZ2UvcG5n/c4db904ea393df7dc19e7b59c77b54f4.png';

// Avatares dos depoimentos — arquivos SVG locais em /public/assets/avatars/
export const AVATARS = [
  '/assets/avatars/avatar-01.svg',
  '/assets/avatars/avatar-02.svg',
  '/assets/avatars/avatar-03.svg',
  '/assets/avatars/avatar-04.svg',
  '/assets/avatars/avatar-05.svg',
  '/assets/avatars/avatar-06.svg',
  '/assets/avatars/avatar-07.svg',
  '/assets/avatars/avatar-08.svg',
  '/assets/avatars/avatar-09.svg',
  '/assets/avatars/avatar-10.svg',
  '/assets/avatars/avatar-11.svg',
  '/assets/avatars/avatar-12.svg',
  '/assets/avatars/avatar-13.svg',
  '/assets/avatars/avatar-14.svg',
  '/assets/avatars/avatar-15.svg',
  '/assets/avatars/avatar-16.svg',
];

// Ícones de navegadores — URLs confiáveis com os logos oficiais
export const BROWSER_ICONS = [
  {
    name: 'Chrome',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/e/e1/Google_Chrome_icon_%28February_2022%29.svg',
  },
  {
    name: 'Edge',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/9/98/Microsoft_Edge_logo_%282019%29.svg',
  },
  {
    name: 'Opera',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/4/49/Opera_2015_icon.svg',
  },
  {
    name: 'Brave',
    icon: 'https://media-manager-c.questera.ai/greta-media/5f22964fb9b032fe91527ae65177c13422882050f0f2b49d154be5b3ce89a1d6adafbd1f2a8bd63b4674e902697722d9/images/aW1hZ2UvcG5n/87d00b3479da81cf1a3a98daef726965.png',
  },
  {
    name: 'Firefox',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/a/a0/Firefox_logo%2C_2019.svg',
  },
  {
    name: 'Safari',
    icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/safari/safari-original.svg',
  },
];